export default __webpack_public_path__ + "static/media/tax_3.d946953f.jpg";